var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.imageUrls.length > 0
    ? _c(
        "div",
        { staticClass: "gallery" },
        [
          _vm.imageUrls.length > 1
            ? [
                _c("lazy-img", {
                  ref: { itemLazyImage: !_vm.disableLazyLoad },
                  attrs: {
                    "image-url": _vm.imageOrItemImage,
                    alt: _vm.getAltText(_vm.imageUrls[0]),
                    title: _vm.getTitleText(_vm.imageUrls[0]),
                    width: _vm.getImageWidth(_vm.imageUrls[0]),
                    height: _vm.getImageHeight(_vm.imageUrls[0]),
                    "picture-class": "mainImg"
                  }
                }),
                _vm._v(" "),
                _c("lazy-img", {
                  ref: { itemLazyImage: !_vm.disableLazyLoad },
                  attrs: {
                    "image-url": _vm.imageUrls[1].url,
                    alt: _vm.getAltText(_vm.imageUrls[1]),
                    title: _vm.getTitleText(_vm.imageUrls[1]),
                    width: _vm.getImageWidth(_vm.imageUrls[1]),
                    height: _vm.getImageHeight(_vm.imageUrls[1]),
                    "picture-class": "secondImg"
                  }
                })
              ]
            : [
                _c("lazy-img", {
                  ref: { itemLazyImage: !_vm.disableLazyLoad },
                  attrs: {
                    "image-url": _vm.imageOrItemImage,
                    alt: _vm.getAltText(_vm.imageUrls[0]),
                    title: _vm.getTitleText(_vm.imageUrls[0]),
                    width: _vm.getImageWidth(_vm.imageUrls[0]),
                    height: _vm.getImageHeight(_vm.imageUrls[0]),
                    "picture-class": "mainImg"
                  }
                })
              ]
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }